import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { AppService } from 'src/app/app.service';

import { OfferComponent } from './offer/offer.component';
import { GroupSaleComponent } from './group-sale/group-sale.component';
//import { OrderLoyaltyComponent } from './order-loyalty/order-loyalty.component';
//import { LoyaltyRegistrationDialogComponent } from './order-loyalty/loyalty-registration-dialog/loyalty-registration-dialog.component';

import * as _ from 'lodash';
import * as moment from 'moment';

@Injectable({
	providedIn: 'root'
})
export class OrderItemsDialogsService {

	constructor(
		private appService: AppService,
		public dialog: MatDialog,
	) {
	}

	openOfferDialog(_offer, isEdit = false) {
		return new Promise((resolve, reject) => {
			let dialogRef = this.dialog.open(OfferComponent, {
				panelClass: ['to-offer-dialog', 'animated', 'fast', 'slideInLeft'],
				backdropClass: 'kiosk-fullscreen-backdrop',
                direction: this.appService.direction,
				//disableClose: true,
				closeOnNavigation: true,
				data: {
					offer: _offer,
					isEdit: isEdit,
					minWidth: 280
				},
				autoFocus: false
			});
			dialogRef.afterClosed().subscribe(result => {
				if (result) {
					resolve(result);
				}
			});
		});
	}

	openOfferBundleDialog($storage, group, mode?) {
		const needCheckCounters = mode == "summary" || mode == "up-sale";
		const maxOffersCount = needCheckCounters ? group.maxOffersInBundle || $storage.folderOptions.maxOffersInBundle || 12 : 12;

		let offers = [];
		group.allOffers.forEach(offer => {
			if (offers.length >= maxOffersCount) return;
			if (needCheckCounters && $storage.order.offerCounters[offer.offer]) return;
			offers.push(offer);
		});
		if (!offers.length) return Promise.resolve();
		group.offers = offers;

		return new Promise((resolve, reject) => {
			let dialogRef = this.dialog.open(GroupSaleComponent, {
				panelClass: 'rounded-dialog-nopad',
				backdropClass: 'dialog-backdrop-dark',
				disableClose: true,
				closeOnNavigation: false,
				minWidth: '95vw',
				//maxWidth: 880,//group.maxDialogWidth || 800,
				//minWidth: 880,//group.maxDialogWidth || 800,
				data: {
					group: group,
					mode: mode,
					minWidth: 280
				},
				autoFocus: false
			});
			dialogRef.afterClosed().subscribe(result => {
				resolve(result);
			});
		});
	}


}
